module.exports = __webpack_public_path__ + "img/r_hone_images_01.81d6ed26.png";